<!--
 * @Date: 2020-05-19 15:46:02
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-28 11:40:46
 * @FilePath: /xy-pc/src/views/userCenter/myCourse/classDetail.vue
--> 

<template>
  <div class="student_myclass" style="width:100%">
    <el-tabs v-model="activeName">
      <el-tab-pane disabled name="first">
        <el-breadcrumb slot="label" style="margin-top: 13px;" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/myCourse' }">我的课程</el-breadcrumb-item>
          <el-breadcrumb-item>课程详情</el-breadcrumb-item>
        </el-breadcrumb>
      </el-tab-pane>
    </el-tabs>
    <el-row :gutter="20">
      <el-col :span="10">
        <el-image style="width: 100%;" :src="courseInfo.thumb_image" fit="contain"></el-image>
      </el-col>
      <el-col :span="14">
        <el-form label-width="80px" label-position="left" size="small">
          <el-form-item label-width="100%">
            <div class="goodsTit" slot="label">{{courseInfo.name}}</div>
          </el-form-item>
          <el-form-item>
            <span class="subTit" slot="label">时间：</span>
            {{courseInfo.begin_at}}~{{courseInfo.end_at}}
          </el-form-item>
          <el-form-item>
            <span class="subTit" slot="label">岗位：</span>
            <div class="jobContent" :class="[{'desc-more ellipsis-2': !isShowMoreDesc}]">
              <span
                style="margin-right:5px"
                v-for="(item ,index) in courseInfo.duties"
                :key="index"
              >{{item}}</span>
              <span class="arrowUp" v-if="!isShowMoreDesc&&courseInfo.duties.join(' ').length>50">
                <i @click="isShowMoreDesc=true" class="el-icon-arrow-down"></i>
              </span>
            </div>
          </el-form-item>
          <el-form-item>
            <span class="subTit" slot="label">课程：</span>
            {{courseInfo.courses.length}}节
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="clearfix" style="padding:10px 0">
      <span class="nubTit">专家：</span>
      <div style="display:inline-block;vertical-align: middle;">
        <div class="avaBox" v-for="(item,index) in courseInfo.experts" :key="index">
          <el-image  style="width:40px;height:40px;border-radius:20px" :size="52" :src="item.avatar"></el-image>
          <div class="avaName">{{item.real_name}}</div>
        </div>
      </div>
    </div>

    <div class="courseDetail">
      <div class="courseHead">
        <span class="tabItem" :class="[activeTab=='1'?'active':'']" @click="activeTab=1">课程列表</span>
        <span class="tabItem" :class="[activeTab=='2'?'active':'']" @click="activeTab=2">课程介绍</span>
      </div>
      <div class="courseContent">
        <div v-if="activeTab==1" class="courseList">
          <div style="width:100%" v-for="(item,index) in courseInfo.courses" :key="index">
            <!-- @click="$router.push({path:'/courseDetail',query:{id:item.id}})" -->
            <div class="clearfix" style="margin-top:3px">
              <div class="capterTit">{{item.title}}</div>
              <div style="float:right; text-align:right;  height: 37px;overflow:hidden">
                <!-- <span><el-rate
                  style="margin-top:5px"
                  v-if="item.see_process==100&&item.is_score"
                  :value="item.score-0"
                  disabled
                ></el-rate></span>-->
                <router-link
                  style="color:#2bbc66"
                  :to="{path:'/playCourse',query:{id:item.id,classId:courseId}}"
                  v-if="!(item.see_process>=100&&!item.is_score)"
                >去学习</router-link>
                <el-button
                  size="small"
                  type="text"
                  v-if="item.see_process>=100&&!item.is_score"
                  @click="class_id=item.id;showReate=true;"
                >去评分</el-button>
              </div>
            </div>
            <div class="clearfix" style="margin:10px 0 23px">
              <span
                class="timeTxt"
                v-if="item.course_see_time"
              >{{item.see_process>=100?item.course_total_time:(formateTime(item.course_see_time))}}/{{item.course_total_time}}</span>
              <div style="float:right;   width:400px;overflow:hidden">
                <el-progress
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="item.see_process>=100?100:(item.see_process-0).toFixed(2)"
                ></el-progress>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="introduce ritchHtml" v-html="courseInfo.introduce">
            <!-- <textarea class="detailtxtArea" readonly :value="courseInfo.introduce"></textarea> -->
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="评分" :visible.sync="showReate" top="30vh">
      <p>
        <strong>老师期待你的评价哦！</strong>评价后即可重复观看课程
      </p>
      <div>
        <el-rate v-model="userScore" style="margin-top:20px"></el-rate>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="postRate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "student_messagebang",

  data() {
    return {
      isShowMoreDesc: false,
      courseId: "",
      userScore: 5,
      activeTab: 1,
      class_id: "",
      classId: "",
      showReate: false,
      courseInfo: {
        score: "",
        thumb_image: "",
        introduce: "",
        end_at: "",
        duties: [],
        begin_at: "",
        courses: [],
        category_name: "",
        chapters: "",
        describe: "",
        expert: "",
        is_buy: "",
        price: "",
        realy_price: "",

        title: "",
      },
      courseProcess: [], //课程进度
      activeName: "first",
    };
  },
  activated() {
    if (this.$route.query && this.$route.query.id) {
      this.courseId = this.$route.query.id;
      this.getClassDetail();
    } else {
      console.log(1);
    }
  },
  created() {},
  filters: {},
  methods: {
    formateTime(value) {
      console.log(value);
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);

      let res = "";
      res += `${h}:${m}:${s}`;
      return res;
    },
    getClassDetail(id) {
      this.$http({
        url: "/api/v1/auth/classes/" + this.courseId,
        method: "get",
      })
        .then((res) => {
          if (res.status == 200) {
            this.courseInfo = Object.assign(
              this.courseInfo,
              {},
              res.data.classes
            );
          } else {
            this.$message.error(res.msg);
            this.$router.replace({ path: "/myCourse" });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("系统错误");
        });
    },
    postRate() {
      this.$http({
        url: "/api/v1/auth/user-courses/" + this.courseId + "/" + this.class_id,
        method: "get",
        params: {
          score: this.userScore,
          user_course_id: this.courseId,
          course_id: this.class_id,
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.showReate = false;
            window.location.reload();
          }
        })
        .catch((err) => {
          this.$message.error("系统错误");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.Personal {
  background: #fff;
}
.courseList {
  width: 600px;
  margin: 0 auto;
  padding-top: 40px;
}
.desc-more {
  position: relative;
  height: 50px; 
  line-height: 34px;
  overflow: hidden;
}
.goodsTit {
  color: rgba(80, 80, 80, 1);
  font-size: 20px;
  line-height: 1.5;
  text-align: left;
  font-weight: bold;
}
.jobContent {
  cursor: pointer; 
  position: relative;
  .arrowUp {
    width: 80px;
    height: 34px;
    text-align: right;
    padding-right: 10px;
    position: absolute;
    display: inline-block;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.1), #fff, #fff);
    right: 0;
    bottom: 0;
  }
}
.subTit {
  color: rgba(128, 128, 128, 1);
  font-size: 18px;
  margin-top: 15px;
}
.courseDetail {
  margin-top: 10px;
  border: rgba(229, 229, 229, 1) solid 1px;
  .courseHead {
    height: 70px;
    border-bottom: rgba(229, 229, 229, 1) solid 1px;
    text-align: center;
    .tabItem {
      display: inline-block;
      margin: 0 80px;
      height: 70px;
      line-height: 70px;
      cursor: pointer;
      &.active {
        border-bottom: 4px solid #2a82e4;
        color: #2a82e4;
      }
    }
  }
  .courseContent {
    padding: 20px;
    min-height: 400px;
    .introduce {
      img {
        max-width: 100%;
      }
    }
  }
}
.Personal_left {
  width: 140px;
  height: 315px;
  left: 415px;
  top: 70px;
  position: relative;
}
.timeTxt {
  width: 143px;
  height: 24px;

  color: rgba(43, 188, 102, 1);
  font-size: 17px;
  line-height: 24px;
  text-align: left;
}
.capterTit {
  width: 450px;
  height: 37px;
  float: left;
  color: rgba(56, 56, 56, 1);
  font-size: 17px;
  line-height: 37px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.contant {
  width: 960px;
  height: 414px;
  left: 615px;
  top: -240px;
  position: relative;
}
.Personal_left li {
  width: 107px;
  height: 27px;
  color: rgba(120, 125, 130, 1);
  font-size: 16px;
  margin-top: 13px;
}
.Personal_left li img {
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: rgba(120, 125, 130, 1);
  position: relative;
  color: #787d82;
  top: 4px;
}
.Personal_left .active {
  width: 140px;
  height: 41px;
  color: #fff;
  background-color: rgba(42, 130, 228, 1);
  border-radius: 12px;
  line-height: 41px;
  text-align: center;
  position: relative;
  left: -26px;
}
.Personal_right {
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  position: relative;
}
.Personal_right .Personal_title {
  height: 28px;
  top: -29px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  line-height: 150%;
  width: 74px;
}
.Personal_hen {
  width: 960px;
  height: 1px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(153, 153, 153, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  position: relative;
  top: -25px;
}
.contant_list {
  margin-top: 15px;
  height: 85px;
}
.Personal_right .blues {
  color: rgba(42, 130, 228, 1);
}
.Personal_right .blue {
  width: 74px;
  height: 3px;
  left: 0px;
  top: -23px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(42, 130, 228, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  position: relative;
}
.ellipsis-1 {
  width: 600px;
  height: 37px;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  line-height: 150%;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.nubTit {
  width: 68px;
  opacity: 0.88;
  color: rgba(80, 80, 80, 1);
  font-size: 19px;
  margin-right: 29px;
}
.avaBox {
  float: left;
  margin-right: 21px;
  text-align: center;
}
.avaName {
  height: 21px;

  color: rgba(153, 153, 153, 1);
  font-size: 12px;
}
.header img {
  width: 343px;
  height: 187px;
  float: left;
  margin-right: 50px;
}
.post {
  width: 356px;
  height: 34px;
  color: rgba(128, 128, 128, 1);
  font-size: 18px;
  line-height: 150%;
  text-align: left;
  margin-top: 10px;
  float: left;
}
.time {
  width: 357px;
  height: 34px;
  left: 934px;
  top: 411px;
  color: rgba(128, 128, 128, 1);
  font-size: 18px;
  line-height: 150%;
  text-align: left;
  float: left;
  margin-top: 10px;
}
.curriculum {
  width: 345px;
  height: 34px;
  color: rgba(128, 128, 128, 1);
  font-size: 19px;
  line-height: 150%;
  text-align: left;
  float: left;
  margin-top: 10px;
}

.expert img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}
.expert_list {
  width: 52px;
  text-align: center;
  float: left;
  margin-right: 20px;
}
.expertImg {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}
.expert {
  overflow: hidden;
  width: 1020px;
  padding-top: 20px;
}
.expert_name {
  width: 68px;
  height: 41px;
  left: 0;
  top: 20px;
  opacity: 0.88;
  color: #505050;
  font-size: 19px;
  line-height: 150%;
  text-align: center;
  float: left;
  position: relative;
  margin-right: 35px;
}
.detail {
  width: 968px;
  height: 750px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(255, 255, 255, 0.6142857142857143);
  font-size: 15px;
  line-height: 150%;
  border: rgba(166, 166, 166, 0.5714285714285715) solid 1px;
  text-align: center;
  margin-top: 30px;
}
.course_list:first-child {
  margin-top: 50px;
}
.course_list {
  width: 569px;
  margin: 15px auto;
}
.course_head {
  width: 486px;
  height: 37px;
  color: rgba(56, 56, 56, 1);
  font-size: 17px;
  line-height: 150%;
  text-align: left;
  float: left;
}
.course_study {
  width: 68px;
  height: 25px;
  color: rgba(43, 188, 102, 1);
  font-size: 16px;
  line-height: 150%;
  text-align: left;
  float: left;
}
.course_time {
  width: 143px;
  height: 25px;
  color: rgba(43, 188, 102, 1);
  font-size: 17px;
  line-height: 150%;
  float: left;
  text-align: left;
}
.course_jin {
  width: 399px;
  height: 13px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(233, 233, 233, 1);
  box-shadow: rgba(203, 203, 203, 1) solid 1px;
  border-radius: 9px;
  font-size: 20px;
  line-height: 150%;
  float: right;
  text-align: center;
  div {
    width: 68px;
    height: 13px;
    color: rgba(80, 80, 80, 1);
    background-color: rgba(43, 188, 102, 1);
    border-radius: 9px;
    font-size: 20px;
    line-height: 150%;
    text-align: center;
  }
}
.introduce_head {
  width: 126px;
  height: 27px;
  left: 990px;
  top: 792px;
  letter-spacing: 7px;
  color: rgba(0, 0, 0, 1);
  font-size: 21px;
  line-height: 150%;
  text-align: left;
  font-weight: bold;
  margin: 0 auto;
  margin-top: 20px;
}
.introduce_detail {
  width: 854px;
  height: 371px;
  left: 626px;
  top: 894px;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  line-height: 150%;
  text-align: left;
  margin: 0 auto;
  margin-top: 20px;
}
</style>